<cc-box>
  <div class="lg-container" box header>{{'LEAD_GENERATION.CREATOR.POPUP.FONT' | translate }}</div>
  <div box content>
    <div class="box-part">
      <div class="divider">
        <span>{{'LEAD_GENERATION.CREATOR.POPUP.SIZE' | translate }}</span></div>
      <form [formGroup]="popupSettings">
        <mat-radio-group
          class="values"
          formControlName="fontSize">
          <mat-radio-button
            value="22px">{{'LEAD_GENERATION.CREATOR.POPUP.SMALL' | translate }}
          </mat-radio-button>
          <mat-radio-button
            value="32px">{{'LEAD_GENERATION.CREATOR.POPUP.MEDIUM' | translate }}
          </mat-radio-button>
          <mat-radio-button
            value="42px">{{'LEAD_GENERATION.CREATOR.POPUP.LARGE' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </form>
    </div>
    <div class="box-part">
      <div class="divider"><span>{{'LEAD_GENERATION.CREATOR.POPUP.TYPE' | translate }}</span></div>
      <cc-lg-font-select [control]="popupSettings.controls.fontStyle"></cc-lg-font-select>
    </div>
  </div>
</cc-box>
